import AppRecord from './AppRecord.js'
import APP from 'src/main.js'

class BecnhmarkSetup extends AppRecord {
  get description(){
    if (this.issue_id){
      return "\t\tVærdipapir: " + this.issue.name
    }
    if (this.asset_class){
      return "Aktivklasse: " + this.asset_class
    }

    if (this.asset_class_group){
      return "\tUnderaktivklasse: " + this.asset_class_group.name
    }

    return ''
  }
  get entity_benchmark(){
    return this.constructor.employeeStore.entity_benchmarks.find(eb => this.entity_benchmark_id === eb.id)
  }
  get entity(){
    return this.constructor.employeeStore.entitiesById.get(this.entity_benchmark.entity_id)||{}
  }
  get entity_long_name(){
    if(this.entity){
      console.log(this.entity)
      return this.entity.long_name
    } else {
      return undefined
    }
  }
  get issue(){
    return this.constructor.employeeStore.issues.find(iss => iss.id === this.issue_id)||{}
  }
  get benchmark(){
    return this.constructor.employeeStore.issues.find(iss => iss.id === this.benchmark_id)||{}
  }
  get benchmark_weights(){
    return this.constructor.employeeStore.benchmark_weights.filter(bmw => bmw.benchmark_setup_id === this.id)
  }
  get any_weights(){
    return (this.benchmark_weights||{}).length
  }
  get asset_class_group(){
    return this.constructor.employeeStore.asset_class_groups.find(acg => acg.id === this.asset_class_group_id)
  }
  get asset_class_hidden(){
    if (this.asset_class){
      return this.asset_class
    }
    if (this.issue_id){
      return this.issue.asset_class
    }
    if (this.asset_class_group){
      return this.asset_class_group.asset_class
    }
    return null
  }
  get benchmark_percent(){
    let w = (this.benchmark_weights||{}).reduce((acc, object) => {
      return acc + object.weight
    }, 0) * 100

    return Math.round(w * 100 ) / 100
  }
  get benchmark_weight_issues(){
    if (this.any_weights == 0){
      return []
    } else {
      var bmws = this.constructor.employeeStore.benchmark_weights.filter(bmw => bmw.benchmark_setup_id === this.id)
      return bmws.map((bmw) => {
        const iss = this.constructor.employeeStore.issues.find(iss => iss.id === bmw.issue_id)||{}
        return {
          weight: bmw.formatted_weight,
          id: bmw.id,
          issue: iss
        }
      })
    }
  }
  get sortOrder(){
    let sortOrder = 0

    if (this.asset_class_hidden) {
      switch (this.asset_class_hidden) {
        case 'Total': sortOrder = 100000000; break;
        case 'Aktier': sortOrder = 200000000; break;
        case 'Obligationer': sortOrder = 300000000; break;
        case 'Hedgerfonde': sortOrder = 400000000; break;
        case 'Finansiering': sortOrder = 500000000; break;
        case 'Ejendomme': sortOrder = 600000000; break;
        case 'Private Equity': sortOrder = 700000000; break;
        case 'Infrastruktur': sortOrder = 800000000; break;
        case 'Multi Strategi': sortOrder = 900000000; break;
        case 'Direkte investeringer': sortOrder = 1000000000; break;
        default: sortOrder = 2000000000; break;
      }
    }

    let acg = (this.asset_class_group || this.issue.asset_class_group)

    if (acg){
      if (acg.sort_order && acg.sort_order != 0){
        sortOrder += acg.sort_order * 100000
      } else {
        sortOrder += 100000
      }
    }

    if (this.issue_id){
      sortOrder += this.issue_id
    }

    return sortOrder
  }

  get benchmarkWeightsValidForAllocation(){
    if (this.asset_class === 'Total'){
      return !this.benchmark_weights.some(x => x.issue.asset_class_group_id === null)
    }

    return true
  }
}
export default BecnhmarkSetup
